import type { ReactNode } from "react";
import { Panel } from "./primitives.js";
import "./game-flow.css";

export function GameSectionHeader({
  suit,
  title,
  hint,
}: {
  suit: "♠" | "♥" | "♣" | "♦";
  title: string;
  hint?: string;
}) {
  return (
    <header className="game-section-header">
      <span className="game-section-suit" aria-hidden="true">{suit}</span>
      <span>
        <strong>{title}</strong>
        {hint !== undefined && <small>{hint}</small>}
      </span>
    </header>
  );
}

export function GameOptionCard({
  title,
  meta,
  badge,
  selected = false,
  disabled = false,
  onClick,
}: {
  title: string;
  meta?: ReactNode;
  badge?: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={`game-option-card${selected ? " game-option-selected" : ""}`}
      aria-pressed={selected}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="game-option-copy">
        <strong>{title}</strong>
        {meta !== undefined && <small>{meta}</small>}
      </span>
      {badge !== undefined && <span className="game-option-badge">{badge}</span>}
    </button>
  );
}

export function MatchConfigurationSummary({
  eyebrow,
  title,
  rows,
  status,
  actions,
  className,
}: {
  eyebrow: string;
  title: string;
  rows: Array<{ label: string; value: ReactNode }>;
  status?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <Panel tone="accent" className={`match-config-summary${className ? ` ${className}` : ""}`}>
      <header>
        <span>{eyebrow}</span>
        <h3>{title}</h3>
        {status !== undefined && <div className="match-config-status">{status}</div>}
      </header>
      <dl>
        {rows.map((row) => (
          <div key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>
      {actions !== undefined && <footer>{actions}</footer>}
    </Panel>
  );
}
